import axios from "axios"
import { getRequestConfig } from "./auth"
import { ApiGateway } from "../config/config"

const resolveEventId = () => {
  try {
    if (window?.crypto?.randomUUID) {
      return window.crypto.randomUUID()
    }
    if (window?.crypto?.getRandomValues) {
      const bytes = new Uint8Array(16)
      window.crypto.getRandomValues(bytes)
      bytes[6] = (bytes[6] & 0x0f) | 0x40
      bytes[8] = (bytes[8] & 0x3f) | 0x80
      const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
      return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
    }
  } catch (e) {
    // no-op: fallback below
  }
  return `evt-${Date.now()}-${Math.random().toString(16).slice(2)}`
}

export const sendActivity = async (activity) => {
  const requestConfig = await getRequestConfig()
  const basePath = `${ApiGateway.user}/activity`

  try {
    await axios.post(basePath, activity, requestConfig)
  } catch (e) {
    const message = e?.response?.data?.error || e?.response?.data?.message || e?.message || 'Unknown activity error'
    console.error('Error on Activity:', message)
  }
}

export const sendFileActivity = async (file, location, activity) => {
  try {
    const fileName = file?.fields?.LinkFilename
    const title = file?.fields?.Title
    const category = file?.fields?.QSEPortalResourceCategory

    const apd = {
      eventId: resolveEventId(),
      clientTs: new Date(),
      eventType: 'file',
      app: 'web',
      event: {
        fileName,
        title,
        category: category ? category.replace(/category:/,'') : null,
        activity,
        ...location
      }
    }

    // Telemetry must never block UI actions.
    sendActivity(apd)
  } catch (e) {
    console.error('Error on file activity payload:', e?.message || e)
  }
}